/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'file': {
    width: 24.1,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path d="M21.3 2.7v18.7H2.7V2.7h18.6m0-2.7H2.7C1.2 0 0 1.2 0 2.7v18.7C0 22.8 1.2 24 2.7 24h18.7c1.5 0 2.7-1.2 2.7-2.7V2.7C24 1.2 22.8 0 21.3 0z"></path><path d="M14.7 18.7H5.3V16h9.3v2.7zm4-5.4H5.3v-2.7h13.3v2.7zm0-5.3H5.3V5.3h13.3V8z"></path>'
  }
})
